import axios from 'axios'
import { BUSCAR_ULTIMOS_HISTORICOS_TRECHO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarUltimosHistoricosTrecho (trechoId, empresaId) {
  let url = `${URL}/trecho/${trechoId}/empresa/${empresaId}/historicos`;
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ULTIMOS_HISTORICOS_TRECHO,
        payload: response

      })
  );
}
